import axios from 'axios'
import { config } from '@/store/index'

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  ...config
})

export default instance
